import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function ProfilWebsite({ companyId }) {
  const [form, setForm] = useState({
    nama_web: '', short_name: '', sector: '', alamat: '', telepon: '', email: '', website: '', deskripsi: '', poin: []
  });
  const [logoFile, setLogoFile] = useState(null);
  const [fotoFile, setFotoFile] = useState(null);
  const [galeriFiles, setGaleriFiles] = useState([null, null, null, null]);
  const [logoPreview, setLogoPreview] = useState(null);
  const [fotoPreview, setFotoPreview] = useState(null);
  const [galeriPreviews, setGaleriPreviews] = useState([null, null, null, null]);
  const [existingLogo, setExistingLogo] = useState(null);
  const [existingFoto, setExistingFoto] = useState(null);
  const [existingGaleri, setExistingGaleri] = useState([null, null, null, null]);
  const [logoPath, setLogoPath] = useState(null);
  const [newPoin, setNewPoin] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  const logoRef = useRef();
  const fotoRef = useRef();
  const galeriRefs = [useRef(), useRef(), useRef(), useRef()];

  useEffect(() => { loadProfile(); }, [companyId]);

  const loadProfile = async () => {
    try {
      const params = companyId ? { company_id: companyId } : {};
      const res = await axios.get(`${API}/api/website-profile`, { params });
      const d = res.data;
      setForm({
        nama_web: d.nama_web || '', short_name: d.short_name || '', sector: d.sector || '',
        alamat: d.alamat || '', telepon: d.telepon || '', email: d.email || '',
        website: d.website || '', deskripsi: d.deskripsi || '', poin: d.poin || []
      });
      if (d.logo_filename) setExistingLogo(`${API}/api/website-profile/image/${d.logo_filename}`);
      if (d.foto_filename) setExistingFoto(`${API}/api/website-profile/image/${d.foto_filename}`);
      if (d.logo_path) setLogoPath(d.logo_path);
      if (d.galeri) {
        setExistingGaleri(d.galeri.map(g => g ? `${API}/api/website-profile/image/${g}` : null));
      }
    } catch {}
  };

  const handleLogoChange = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setLogoFile(f);
    setLogoPreview(URL.createObjectURL(f));
  };

  const handleFotoChange = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setFotoFile(f);
    setFotoPreview(URL.createObjectURL(f));
  };

  const handleGaleriChange = (index, e) => {
    const f = e.target.files[0];
    if (!f) return;
    const newFiles = [...galeriFiles];
    newFiles[index] = f;
    setGaleriFiles(newFiles);
    const newPreviews = [...galeriPreviews];
    newPreviews[index] = URL.createObjectURL(f);
    setGaleriPreviews(newPreviews);
  };

  const addPoin = () => {
    if (!newPoin.trim()) return;
    setForm(f => ({ ...f, poin: [...f.poin, newPoin.trim()] }));
    setNewPoin('');
  };

  const removePoin = (i) => setForm(f => ({ ...f, poin: f.poin.filter((_, idx) => idx !== i) }));
  const movePoin = (i, dir) => {
    const arr = [...form.poin];
    const j = i + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[i], arr[j]] = [arr[j], arr[i]];
    setForm(f => ({ ...f, poin: arr }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true); setMsg('');
    try {
      const fd = new FormData();
      fd.append('nama_web', form.nama_web);
      fd.append('short_name', form.short_name);
      fd.append('sector', form.sector);
      fd.append('alamat', form.alamat);
      fd.append('telepon', form.telepon);
      fd.append('email', form.email);
      fd.append('website', form.website);
      fd.append('deskripsi', form.deskripsi);
      fd.append('poin', JSON.stringify(form.poin));
      if (companyId) fd.append('company_id_param', companyId);
      if (logoFile) fd.append('logo', logoFile);
      if (fotoFile) fd.append('foto', fotoFile);
      galeriFiles.forEach((gf, i) => {
        if (gf) fd.append(`galeri_${i+1}`, gf);
      });
      await axios.put(`${API}/api/website-profile`, fd);
      setMsg('Profil berhasil disimpan!');
      loadProfile();
    } catch { setMsg('Gagal menyimpan'); } finally { setSaving(false); }
  };

  if (companyId === null) return <div style={s.empty}>Pilih perusahaan terlebih dahulu dari menu "Semua Perusahaan"</div>;

  const currentLogo = logoPreview || existingLogo || logoPath;
  const currentFoto = fotoPreview || existingFoto;

  return (
    <div>
      <div style={s.header}>
        <h2 style={s.h2}>🌐 Profil Website</h2>
        <button style={s.previewBtn} onClick={() => setShowPreview(!showPreview)}>
          {showPreview ? '✏️ Edit' : '👁️ Preview'}
        </button>
      </div>
      {msg && <div style={{ ...s.msg, color: msg.includes('berhasil') ? '#16a34a' : '#dc2626' }}>{msg}</div>}

      {showPreview ? (
        <PreviewCard form={form} logo={currentLogo} foto={currentFoto} galeri={galeriPreviews.map((p, i) => p || existingGaleri[i])} />
      ) : (
        <form onSubmit={handleSave}>
          <div style={s.grid2}>
            {/* Logo */}
            <div style={s.card}>
              <h3 style={s.cardTitle}>🖼️ Logo Perusahaan</h3>
              <div style={s.imgBox} onClick={() => logoRef.current.click()}>
                {currentLogo ? <img src={currentLogo} alt="logo" style={s.img} /> : <div style={s.imgPlaceholder}>Klik untuk upload logo</div>}
              </div>
              <input type="file" ref={logoRef} accept="image/*" style={{ display: 'none' }} onChange={handleLogoChange} />
              <button type="button" style={s.uploadBtn} onClick={() => logoRef.current.click()}>Ganti Logo</button>
            </div>

            {/* Foto Utama */}
            <div style={s.card}>
              <h3 style={s.cardTitle}>📸 Foto / Banner Utama</h3>
              <div style={s.imgBox} onClick={() => fotoRef.current.click()}>
                {currentFoto ? <img src={currentFoto} alt="foto" style={s.img} /> : <div style={s.imgPlaceholder}>Klik untuk upload foto/banner</div>}
              </div>
              <input type="file" ref={fotoRef} accept="image/*" style={{ display: 'none' }} onChange={handleFotoChange} />
              <button type="button" style={s.uploadBtn} onClick={() => fotoRef.current.click()}>Ganti Foto</button>
            </div>
          </div>

          {/* Info Dasar */}
          <div style={s.card}>
            <h3 style={s.cardTitle}>🏢 Informasi Dasar</h3>
            <div style={s.grid2}>
              <div style={s.field}>
                <label style={s.label}>Nama Perusahaan</label>
                <input style={s.input} value={form.nama_web} onChange={e => setForm(f => ({ ...f, nama_web: e.target.value }))} placeholder="PT Nama Perusahaan" />
              </div>
              <div style={s.field}>
                <label style={s.label}>Nama Singkat / Brand</label>
                <input style={s.input} value={form.short_name} onChange={e => setForm(f => ({ ...f, short_name: e.target.value }))} placeholder="Brand Name" />
              </div>
              <div style={s.field}>
                <label style={s.label}>Sektor / Bidang Usaha</label>
                <input style={s.input} value={form.sector} onChange={e => setForm(f => ({ ...f, sector: e.target.value }))} placeholder="Tour & Travel, IT, dll" />
              </div>
              <div style={s.field}>
                <label style={s.label}>Website</label>
                <input style={s.input} value={form.website} onChange={e => setForm(f => ({ ...f, website: e.target.value }))} placeholder="www.perusahaan.com" />
              </div>
              <div style={s.field}>
                <label style={s.label}>Email</label>
                <input style={s.input} type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="email@perusahaan.com" />
              </div>
              <div style={s.field}>
                <label style={s.label}>Nomor Telepon</label>
                <input style={s.input} value={form.telepon} onChange={e => setForm(f => ({ ...f, telepon: e.target.value }))} placeholder="+62 21 xxx xxxx" />
              </div>
            </div>
            <div style={s.field}>
              <label style={s.label}>Alamat Kantor</label>
              <input style={s.input} value={form.alamat} onChange={e => setForm(f => ({ ...f, alamat: e.target.value }))} placeholder="Alamat lengkap kantor..." />
            </div>
            <div style={s.field}>
              <label style={s.label}>Deskripsi Perusahaan</label>
              <textarea style={{ ...s.input, height: '90px', resize: 'vertical' }} value={form.deskripsi} onChange={e => setForm(f => ({ ...f, deskripsi: e.target.value }))} placeholder="Deskripsi singkat tentang perusahaan..." />
            </div>
          </div>

          {/* Galeri */}
          <div style={s.card}>
            <h3 style={s.cardTitle}>🖼️ Galeri Gambar (4 Gambar)</h3>
            <div style={s.grid4}>
              {[0, 1, 2, 3].map(i => (
                <div key={i} style={s.galeriItem}>
                  <div style={s.galeriBox} onClick={() => galeriRefs[i].current.click()}>
                    {galeriPreviews[i] || existingGaleri[i] ? (
                      <img src={galeriPreviews[i] || existingGaleri[i]} alt={`galeri ${i+1}`} style={s.img} />
                    ) : (
                      <div style={s.galeriPlaceholder}>
                        <span style={{fontSize: '24px', opacity: 0.5}}>📷</span>
                        <span>Gambar {i+1}</span>
                      </div>
                    )}
                  </div>
                  <input type="file" ref={galeriRefs[i]} accept="image/*" style={{ display: 'none' }} onChange={(e) => handleGaleriChange(i, e)} />
                  <button type="button" style={s.smallBtn} onClick={() => galeriRefs[i].current.click()}>Upload</button>
                </div>
              ))}
            </div>
          </div>

          {/* Poin-Poin */}
          <div style={s.card}>
            <h3 style={s.cardTitle}>📝 Poin-Poin Utama</h3>
            <div style={s.poinInputRow}>
              <input style={{ ...s.input, flex: 1 }} value={newPoin} onChange={e => setNewPoin(e.target.value)} onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addPoin())} placeholder="Tulis poin, tekan Enter atau klik Tambah..." />
              <button type="button" style={s.addPoinBtn} onClick={addPoin}>+ Tambah</button>
            </div>
            {form.poin.length === 0 ? (
              <div style={s.poinEmpty}>Belum ada poin. Tambahkan di atas.</div>
            ) : (
              <div style={s.poinList}>
                {form.poin.map((p, i) => (
                  <div key={i} style={s.poinItem}>
                    <span style={s.poinBullet}>●</span>
                    <span style={{ flex: 1 }}>{p}</span>
                    <button type="button" style={s.poinMove} onClick={() => movePoin(i, -1)} disabled={i === 0}>↑</button>
                    <button type="button" style={s.poinMove} onClick={() => movePoin(i, 1)} disabled={i === form.poin.length - 1}>↓</button>
                    <button type="button" style={s.poinDel} onClick={() => removePoin(i)}>✕</button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={s.saveRow}>
            <button type="submit" style={s.saveBtn} disabled={saving}>{saving ? 'Menyimpan...' : '💾 Simpan Semua Perubahan'}</button>
          </div>
        </form>
      )}
    </div>
  );
}

function PreviewCard({ form, logo, foto, galeri }) {
  return (
    <div style={pv.wrap}>
      <div style={pv.banner}>
        {foto ? <img src={foto} alt="banner" style={pv.bannerImg} /> : <div style={pv.bannerPlaceholder}>Belum ada foto banner</div>}
        {logo && <img src={logo} alt="logo" style={pv.logo} />}
      </div>
      <div style={pv.body}>
        <h1 style={pv.nama}>{form.nama_web || 'Nama Perusahaan'}</h1>
        {form.short_name && <p style={pv.shortName}>{form.short_name}</p>}
        {form.sector && <span style={pv.sector}>{form.sector}</span>}
        
        {/* Galeri Preview */}
        <div style={pv.galeriGrid}>
          {galeri.map((g, i) => (
            <div key={i} style={pv.galeriItem}>
              {g ? <img src={g} alt={`galeri ${i+1}`} style={pv.galeriImg} /> : <div style={pv.galeriPlaceholder}>Gambar {i+1}</div>}
            </div>
          ))}
        </div>

        {form.deskripsi && <p style={pv.desc}>{form.deskripsi}</p>}
        {form.poin.length > 0 && (
          <div style={pv.poinSection}>
            <h3 style={pv.poinTitle}>Poin Utama</h3>
            <ul style={pv.poinList}>
              {form.poin.map((p, i) => <li key={i} style={pv.poinItem}>● {p}</li>)}
            </ul>
          </div>
        )}
        <div style={pv.info}>
          {form.alamat && <div style={pv.infoRow}>📍 {form.alamat}</div>}
          {form.telepon && <div style={pv.infoRow}>📞 {form.telepon}</div>}
          {form.email && <div style={pv.infoRow}>✉️ {form.email}</div>}
          {form.website && <div style={pv.infoRow}>🌐 {form.website}</div>}
        </div>
      </div>
    </div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  h2: { fontSize: '20px', fontWeight: '700', color: '#1a1a2e', margin: 0 },
  previewBtn: { padding: '8px 18px', background: '#f0fdf4', color: '#16a34a', border: '1.5px solid #bbf7d0', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' },
  msg: { padding: '10px 14px', background: '#f0fdf4', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' },
  grid4: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' },
  card: { background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '16px' },
  cardTitle: { fontSize: '15px', fontWeight: '700', color: '#1a1a2e', marginBottom: '14px', margin: '0 0 14px' },
  imgBox: { width: '100%', height: '140px', border: '2px dashed #e5e7eb', borderRadius: '10px', cursor: 'pointer', overflow: 'hidden', marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  img: { width: '100%', height: '100%', objectFit: 'contain' },
  imgPlaceholder: { color: '#9ca3af', fontSize: '13px', textAlign: 'center', padding: '10px' },
  uploadBtn: { padding: '6px 14px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '7px', cursor: 'pointer', fontSize: '13px', width: '100%' },
  field: { marginBottom: '12px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '5px' },
  input: { width: '100%', padding: '9px 12px', border: '1.5px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
  galeriItem: { display: 'flex', flexDirection: 'column', gap: '6px' },
  galeriBox: { width: '100%', aspectRatio: '4/3', border: '2px dashed #e5e7eb', borderRadius: '8px', cursor: 'pointer', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  galeriPlaceholder: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', color: '#9ca3af', fontSize: '12px' },
  smallBtn: { padding: '4px 8px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  poinInputRow: { display: 'flex', gap: '10px', marginBottom: '12px' },
  addPoinBtn: { padding: '9px 16px', background: '#1a1a2e', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', whiteSpace: 'nowrap' },
  poinEmpty: { color: '#9ca3af', fontSize: '13px', textAlign: 'center', padding: '10px' },
  poinList: { display: 'flex', flexDirection: 'column', gap: '6px' },
  poinItem: { display: 'flex', alignItems: 'center', gap: '8px', background: '#f9fafb', borderRadius: '8px', padding: '8px 12px', fontSize: '14px' },
  poinBullet: { color: '#1d4ed8', fontSize: '10px' },
  poinMove: { padding: '2px 6px', background: '#e5e7eb', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '11px', color: '#374151' },
  poinDel: { padding: '2px 7px', background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' },
  saveRow: { display: 'flex', justifyContent: 'flex-end', marginTop: '4px' },
  saveBtn: { padding: '12px 28px', background: '#1a1a2e', color: 'white', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '700', cursor: 'pointer' },
  empty: { background: 'white', borderRadius: '12px', padding: '40px', textAlign: 'center', color: '#9ca3af', fontSize: '14px' }
};

const pv = {
  wrap: { background: 'white', borderRadius: '14px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', maxWidth: '800px' },
  banner: { position: 'relative', height: '200px', background: '#1a1a2e', overflow: 'hidden' },
  bannerImg: { width: '100%', height: '100%', objectFit: 'cover' },
  bannerPlaceholder: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: 'rgba(255,255,255,0.4)', fontSize: '14px' },
  logo: { position: 'absolute', bottom: '12px', left: '16px', width: '60px', height: '60px', objectFit: 'contain', background: 'white', borderRadius: '8px', padding: '4px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' },
  body: { padding: '20px 24px' },
  nama: { fontSize: '22px', fontWeight: '800', color: '#1a1a2e', marginBottom: '4px', marginTop: 0 },
  shortName: { fontSize: '14px', color: '#29ABE2', margin: '0 0 8px', fontWeight: '500' },
  sector: { display: 'inline-block', fontSize: '12px', background: '#f0f8f4', color: '#1a1a2e', padding: '4px 12px', borderRadius: '20px', marginBottom: '16px' },
  galeriGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px', margin: '16px 0' },
  galeriItem: { aspectRatio: '4/3', borderRadius: '8px', overflow: 'hidden', background: '#f3f4f6' },
  galeriImg: { width: '100%', height: '100%', objectFit: 'cover' },
  galeriPlaceholder: { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', color: '#9ca3af' },
  desc: { fontSize: '14px', color: '#4b5563', lineHeight: 1.6, marginBottom: '16px' },
  poinSection: { marginBottom: '16px' },
  poinTitle: { fontSize: '14px', fontWeight: '700', color: '#29ABE2', marginBottom: '8px' },
  poinList: { listStyle: 'none', padding: 0, margin: 0 },
  poinItem: { fontSize: '13px', color: '#374151', padding: '4px 0' },
  info: { borderTop: '1px solid #f3f4f6', paddingTop: '14px', display: 'flex', flexDirection: 'column', gap: '6px' },
  infoRow: { fontSize: '13px', color: '#6b7280' }
};
